import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { HeaderNavAction } from "../actions";
// import { useDispatch, useSelector } from "react-redux";

const Header = () => {
    const HeaderNav = useSelector((state) => state.headerNav);
    const isAuthMemGroup = useSelector((state) => state.authmemgroup);
    const dispatch = useDispatch();

    return (
        <header className="z-10">
            <div
                className={`h-22 z-40  py-2 bg-blue-200 shadow-md  fixed top-0 left-0 w-full bg-gradient-to-r from-[#41a4fc] via-[#00b4d8] to-[#90e0ef]
            `}
            >
                <div className="flex py-1 pt-1 text-sky-600 ">
                    <dev className="mt-1 ml-6 text-md xl:text-xl lg:text-xl md:text-lg font-bold text-white ">
                        {/* <i className="fas fa-user-alt fa-1x"></i> */}
                        &nbsp;ระบบตรวจสอบใบแจ้งหนี้สำหรับหน่วยงาน
                    </dev>
                    {/* <!-- Mobile hamburger --> */}
                    <button
                        className="bg-white border-2 border-sky-700 px-2 mr-5 ml-4 rounded lg:hidden focus:outline-none focus:shadow-outline-purple"
                        onClick={() => {
                            // console.log('message');
                            console.log(HeaderNav.opened);
                            dispatch(
                                HeaderNavAction.onToggleOpened(HeaderNav.opened)
                            );
                        }}
                        aria-label="Menu"
                    >
                        เมนู
                        <svg
                            className="pl-1 w-6 h-6 inline-block"
                            aria-hidden="true"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                        >
                            <path
                                fillRule="evenodd"
                                d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                                clipRule="evenodd"
                            ></path>
                        </svg>
                    </button>
                </div>
            </div>
            <div className="flex pt-16 flex-wrap items-center">
                <div className="flex justify-center  w-full md:w-1/6">
                    <img
                        src="mediafiles/images/Utils/cooplogo.png"
                        className="w-28 h-28 xl:w-40 xl:h-40 animate-pulse rounded-full "
                        alt={`โลโก้ ${window.config.coopNameTH}`}
                    />
                </div>
                <div className="w-full md:w-5/6 lg:pl-12 text-left">
                    <h1
                        className="intro-x text-gradient text-center lg:text-left bg-clip-text text-transparent bg-gradient-to-r from-custom-800
                    to-custom-600 no-m m-t-xs py-2 text-base xl:text-4xl lg:text-2xl md:text-xl font-bold overflow-hidden intro-x"
                    >
                        {window.config.coopNameTH}
                    </h1>
                    <h2
                        className="intro-x no-m  text-custom-700 text-center md:text-left text-xs xl:text-lg lg:text-lg intro-y
                    md:text-sm font-bold  overflow-hidden"
                    >
                        {window.config.coopNameEN}
                    </h2>
                    <h3 className="intro-x mb-0 text-custom-800 text-center md:text-left font-normal text-sm md:text-base lg:text-lg xl:text-2xl">
                        <i className="fas fa-user-circle fa-1x "></i>{" "}
                        <label className="font-light">หน่วยงาน</label>
                        {isAuthMemGroup &&
                            isAuthMemGroup.loggedIn &&
                            ` : ${isAuthMemGroup.user.member_group_no.substring(4)}`}
                    </h3>
                </div>
            </div>
        </header>
    );
};

export default Header;
